///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/collection-model.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>


module Meevo.Components.Controls.SmartMover {
    import ISmartMoverModel = Meevo.Components.Controls.SmartMover.ISmartMoverModel;
    import IReportDP005Product = Meevo.Plugins.Reports.IReportDP005Product;

    export class Dp005ProductModel extends SmartMoverModel<IReportDP005Product> implements ISmartMoverModel<IReportDP005Product> {
        disabled: boolean;

        get displayName(): string {
            const variant: string = this.get('variantDisplayName') ? ` - ${this.get('variantDisplayName')}` : '';
            const sku: string = this.get('sku') ? `${this.get('sku')}: ` : '';

            return `${sku}${this.get('productDisplayName')}${variant}`;
        }
    }
}
